import type { ChannelFilters, ChannelOptions, ChannelSort } from "stream-chat";
import type { DefaultStreamChatGenerics } from "stream-chat-react";

import { useSearchParams } from "react-router";
import { Channel, ChannelHeader, ChannelList, Chat, MessageInput, MessageList, Thread, Window } from "stream-chat-react";

import { useStreamClient } from "@/context/stream-context";
import { useMe } from "@/context/user-context";

export function MessageClient() {
  const [searchParams] = useSearchParams();

  const channelId = searchParams.get("channelId") || undefined;
  const { user } = useMe();
  const streamClient = useStreamClient();

  // Club freemium : aucun client de chat, la page messagerie affiche déjà un
  // upsell en amont. Garde de sûreté si on arrive ici quand même.
  if (!streamClient) {
    return null;
  }

  const filters: ChannelFilters<DefaultStreamChatGenerics> = {
    members: { $in: [user.id] },
    type: "messaging",
    archived: false,
    joined: {
      $eq: true,
    },
  };
  const options: ChannelOptions = { presence: true, state: true };
  const sort: ChannelSort<DefaultStreamChatGenerics> = { last_message_at: -1 };

  return (
    <Chat client={streamClient} initialNavOpen>
      <ChannelList
        sort={sort}
        options={options}
        filters={filters}
        customActiveChannel={channelId}
      />
      <Channel>
        <Window>
          <ChannelHeader />
          <MessageList />
          <MessageInput />
        </Window>
        <Thread />
      </Channel>
    </Chat>
  );
}
